import React, { useCallback, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './Particles.css';

export const Particles = () => {
  const [particles, setParticles] = useState([]);

  // Generate particles on mount
  useEffect(() => {
    const particleCount = Math.min(40, Math.floor(window.innerWidth / 30));
    const newParticles = Array.from({ length: particleCount }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 4 + 2,
      duration: Math.random() * 20 + 15,
      delay: Math.random() * 5,
      opacity: Math.random() * 0.5 + 0.2,
    }));
    setParticles(newParticles);
  }, []);

  const getRandomPath = useCallback((index) => {
    const seed = index * 0.1;
    return {
      x: [
        `${Math.sin(seed) * 15}%`,
        `${Math.sin(seed + 1) * 20}%`,
        `${Math.sin(seed + 2) * 15}%`,
        `${Math.sin(seed + 3) * 20}%`,
        `${Math.sin(seed) * 15}%`,
      ],
      y: [
        `${Math.cos(seed) * 15}%`,
        `${Math.cos(seed + 1) * 20}%`,
        `${Math.cos(seed + 2) * 15}%`,
        `${Math.cos(seed + 3) * 20}%`,
        `${Math.cos(seed) * 15}%`,
      ],
    };
  }, []);

  return (
    <div className="particles-container" aria-hidden="true">
      {/* Background Gradient Orbs */}
      <div className="gradient-orb orb-1" />
      <div className="gradient-orb orb-2" />
      <div className="gradient-orb orb-3" />
      
      {/* Animated Particles */}
      {particles.map((particle) => {
        const path = getRandomPath(particle.id);
        return (
          <motion.div
            key={particle.id}
            className="particle"
            style={{
              left: `${particle.x}%`,
              top: `${particle.y}%`,
              width: particle.size,
              height: particle.size,
            }}
            initial={{ opacity: 0, scale: 0 }}
            animate={{
              opacity: [0, particle.opacity, particle.opacity, 0],
              scale: [0, 1, 1, 0],
              x: path.x,
              y: path.y,
            }}
            transition={{
              duration: particle.duration,
              delay: particle.delay,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          />
        );
      })}

      {/* Grid Pattern Overlay */}
      <div className="grid-pattern" />
      
      {/* Noise Texture */}
      <div className="noise-overlay" />
    </div>
  );
};

export default Particles;

